import { createFileRoute } from "@tanstack/react-router";
import { DomainEventsContent } from "@/features/admin/domain-events/domain-events-content";

export const Route = createFileRoute("/admin/domain-events")({
  staticData: {
    title: "领域事件管理",
  },
  ssr: false,
  component: RouteComponent,
});

function RouteComponent() {
  return <DomainEventsContent />;
}
